import React from 'react';

export default () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124">
      <path d="M112 50H12C5.4 50 0 55.4 0 62s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12z" />
    </svg>
  );
};
